import { render, staticRenderFns } from "./Payslips.vue?vue&type=template&id=38174152&scoped=true&lang=html"
import script from "./Payslips.vue?vue&type=script&lang=js"
export * from "./Payslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38174152",
  null
  
)

export default component.exports